// Shared constants for the cover-pages admin module.
// Kept separate from the React components so they're trivially importable.

import { Hourglass, Wrench, Sparkles } from "lucide-react";

export const MODE_META = {
  coming_soon: {
    label: "Coming soon",
    icon: Hourglass,
    description:
      "Shown to public visitors when site mode is set to 'coming_soon'. Authenticated admins always bypass.",
  },
  maintenance: {
    label: "Maintenance",
    icon: Wrench,
    description:
      "Shown to public visitors when site mode is set to 'maintenance'. Use during scheduled downtime.",
  },
  custom: {
    label: "Custom",
    icon: Sparkles,
    description:
      "Your own cover for any other situation. Activate by setting site mode to 'custom' in Integrations.",
  },
};

export const TONE_SWATCH = {
  emerald: "bg-emerald-100 text-emerald-700",
  amber: "bg-amber-100 text-amber-700",
  slate: "bg-slate-100 text-slate-700",
  sky: "bg-sky-100 text-sky-700",
  rose: "bg-rose-100 text-rose-700",
};

export const COVER_FIELDS = [
  "eyebrow",
  "title",
  "body_html",
  "button_label",
  "button_url",
  "image_url",
  "tone",
];
